import { RouteObject, Navigate, Outlet } from 'react-router-dom';
import { SellApartmentFlowPaths } from 'routes';
import ChooseBuilding from 'screens/choose-building';
import ApartmentSaleAds from 'screens/apartment-sale-ads';
import SellApartmentMain from 'screens/sell-apartment-main';
import InputApartmentPrice from 'screens/input-apartment-price';
import InputApartmentNumber from 'screens/input-apartment-number';
import ChooseApartmentComplex from 'screens/choose-apartment-complex';
import Documents from '../screens/documents';
import AddAdditionalOptions from '../screens/add-additional-options';
import SellApartmentNotificationMode from '../screens/sell-apartment-notification-mode';
import DocumentsNotificationMode from '../screens/documents-notification-mode';
import SellFinishScreen from '../screens/sell-finish-screen';
import SellTradeInInformation from '../screens/sell-trade-in-information';
import SellReitInformation from '../screens/sell-rate-information';
import ScreenSellMode from '../screens/choose-sell-mode';
import ApartmentSaleAdsSecondary from '../screens/apartment-sale-ads-secondary';
import SellTabsSecondaryScreen from '../screens/sell-tabs-secondary-screen';
import SellChooseApartmentSecondary from '../screens/sell-choose-apartment-secondary';
import ChoosePriceSecondary from '../screens/choose-price-secondary';
import SellUploadPhotoScreen from '../screens/sell-upload-photo-screen';
import SellApartmentScreensWrapper from 'components/apartments-screen-wrapper';
import { Apartment } from 'screens/apartment';

const sellApartmentFlowRouter: RouteObject[] = [
  {
    path: '/',
    element: <SellApartmentScreensWrapper />,
    children: [
      {
        path: `${SellApartmentFlowPaths.mainSellChooseMode}/*`,
        element: <Navigate to={SellApartmentFlowPaths.main} replace />,
      },
      {
        path: SellApartmentFlowPaths.mainSellChooseMode,
        element: <ScreenSellMode />,
      },
      {
        path: SellApartmentFlowPaths.main,
        element: <SellApartmentMain />,
      },
      {
        path: SellApartmentFlowPaths.chooseApartmentComplex,
        element: <ChooseApartmentComplex />,
      },

      {
        path: SellApartmentFlowPaths.chooseBuilding,
        element: <ChooseBuilding />,
      },
      {
        path: SellApartmentFlowPaths.inputApartmentNumber,
        element: <InputApartmentNumber />,
      },
      {
        path: SellApartmentFlowPaths.inputApartmentPrice,
        element: <InputApartmentPrice />,
      },
      {
        path: SellApartmentFlowPaths.documents,
        element: <Documents />,
      },
      {
        path: SellApartmentFlowPaths.documentsNotificationMode,
        element: <DocumentsNotificationMode />,
      },
      {
        path: SellApartmentFlowPaths.apartmentSaleAds,
        element: <ApartmentSaleAds />,
      },

      {
        path: SellApartmentFlowPaths.apartment,
        element: <Apartment mode='sell' />,
      },
      {
        path: SellApartmentFlowPaths.addAdditionalOptions,
        element: <AddAdditionalOptions />,
      },
      {
        path: SellApartmentFlowPaths.sellNotificationMode,
        element: <SellApartmentNotificationMode />,
      },
      {
        path: SellApartmentFlowPaths.sellNotificationModeId,
        element: <SellApartmentNotificationMode />,
      },
      {
        path: SellApartmentFlowPaths.sellFinishScreen,
        element: <SellFinishScreen />,
      },
      {
        path: SellApartmentFlowPaths.sellTradeInInformation,
        element: <SellTradeInInformation />,
      },
      {
        path: SellApartmentFlowPaths.sellReitInformation,
        element: <SellReitInformation />,
      },
      {
        path: SellApartmentFlowPaths.apartmentSaleAdsSecondary,
        element: <ApartmentSaleAdsSecondary />,
      },
      {
        path: SellApartmentFlowPaths.secondaryTabAddress,
        element: <SellTabsSecondaryScreen />,
      },
      {
        path: SellApartmentFlowPaths.chooseApartmentSecondary,
        element: <SellChooseApartmentSecondary />,
      },
      {
        path: SellApartmentFlowPaths.priceSecondaryScreen,
        element: <ChoosePriceSecondary />,
      },
      {
        path: SellApartmentFlowPaths.uploadPhotoSecondary,
        element: <SellUploadPhotoScreen />,
      },
    ],
  },
];

export default sellApartmentFlowRouter;
